module.exports = __webpack_public_path__ + "templates.facebook-messenger-checkbox-v1-462c5713.html";